<template>
  <section class="blog-article-hero push-v--desktop--large push-v--tablet--large push-v--mobile--large">
    <div class="blog-article-hero__wave" />
    <div :class="backgroundShapeColor" class="blog-article-hero__background-shape" />
    <KenticoResponsiveImage :src="image.url" :alt="image.description" class="blog-article-hero__image" :sizes="imageSizes" />
  </section>
</template>

<script>
import getStatic from '~/utils/get-static';
import { BREAKPOINTS, BREAKPOINT_MD, BREAKPOINT_LG, BREAKPOINT_XL } from '~/utils/constants';

export default {
  props: {
    image: {
      type: Object,
      required: true,
      default() {
        return {
          url: getStatic('/images/content/blog/blog-article-hero.png'),
          description: 'alt tag equivelent',
        };
      },
    },
    backgroundShapeColor: { type: String, default: 'bg--pale-yellow' },
  },
  data() {
    return {
      imageSizes: {
        default: [1500, 1000],
        sizes: [
          { breakpoint: BREAKPOINTS[BREAKPOINT_MD], width: 1200, height: 800 },
          { breakpoint: BREAKPOINTS[BREAKPOINT_LG], width: 1500, height: 1000 },
          { breakpoint: BREAKPOINTS[BREAKPOINT_XL], width: 1800, height: 1200 },
        ],
      },
    };
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_blog-article-hero.scss';
</style>
